import { Component } from '@angular/core';
import { PrimeNgArrayD4Component } from '../shared/prime-ng-array-d4/prime-ng-array-d4.component';
import { MaterialModule } from '../material-module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { GetJsonObjectService } from '../shared/services/get-json-object.service';
import { PutJsonObjectService } from '../shared/services/put-json-object.service';
import { first, forkJoin } from 'rxjs';
import { columnDefinition, twoLinesDisplay } from '../shared/prime-ng-array-d4/prime-ng-array-d4.service';
import { environment } from '../../environments/environment';
import { deviceService } from '../shared/servicesHardware/deviceService';

@Component({
  selector: 'app-factures',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, PrimeNgArrayD4Component, MaterialModule],
  templateUrl: './factures.html',
  styleUrl: './factures.scss'
})
export class Factures {

  public columnsDefinition: columnDefinition[] = [];
  public invoices: any[] = [];
  public loading: boolean = true;
  private dowloadImgB64: string = "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAwMDAwIj48cGF0aCBkPSJNNDgwLTMyMCAyODAtNTIwbDU2LTU4IDEwNCAxMDR2LTMyNmg4MHYzMjZsMTA0LTEwNCA1NiA1OC0yMDAgMjAwWk0yNDAtMTYwcS0zMyAwLTU2LjUtMjMuNVQxNjAtMjQwdi0xMjBoODB2MTIwaDQ4MHYtMTIwaDgwdjEyMHEwIDMzLTIzLjUgNTYuNVQ3MjAtMTYwSDI0MFoiLz48L3N2Zz4="

  constructor(
    private getJsonObjectService: GetJsonObjectService,
    private putJsonService: PutJsonObjectService,
    private deviceService: deviceService
  ) {
    this.getDatas();
    this.columnsDefinition = [
      { displayName: "Pointage", name: "customerValidation", readOnly: false, ngStyle: { 'flex.px': '0 0 130' }, type: 'booleanCheckBoxSwitch', enum: null, drop: null, localFilter: true },
      { displayName: "Facture", name: "invoiceNumber", readOnly: true, ngStyle: { 'flex.px': '0 0 150' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Libellé", name: "invoiceDescription", readOnly: true, ngStyle: { 'flex.px': '0 0 500' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Société", name: "subscriberName", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Statut", name: "administrativeStatus", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'string', enum: null, drop: null, localFilter: true },
      { displayName: "Date", name: "issueDate", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'date', enum: null, drop: null, localFilter: true },
      { displayName: "Échéance", name: "dueDate", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'date', enum: null, drop: null, localFilter: true },
      { displayName: "Montant TTC", name: "totalAmount", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'currency', enum: null, drop: null, localFilter: true },
      { displayName: "Restant dû", name: "outstandingBalance", readOnly: true, ngStyle: { 'flex.px': '0 0 130' }, type: 'currency', enum: null, drop: null, localFilter: true },
      {
        displayName: "Télécharger", name: "download", readOnly: true, ngStyle: { 'flex.px': '1 0 80', 'cursor': 'pointer' }, type: 'link', enum: null, drop: null, localFilter: false,
        printLine: {
          methodImplementation: (object) => {
            if (object?.download != null) {
              let returnValue: twoLinesDisplay = {
                topLine: ' <img style="cursor: pointer;" src="data:image/svg+xml;base64,' + this.dowloadImgB64 + '" />',
                bottomLine: ""
              }
              return returnValue
            }
            else {
              let returnValue: twoLinesDisplay = {
                topLine: '<span style="text-align: right"> </span>',
                bottomLine: ""
              }
              return returnValue
            }
          }
        },
      },
    ];
  }

  public rowAction(event: any) {
    console.log(event);
    let oldValue = event?.oldValue.customerValidation
    let newValue = event?.newValue.customerValidation
    if (oldValue != undefined && newValue != undefined && oldValue != newValue) {
      this.putJsonService.sendJson("cm/invoices/" + event.newValue.orderUniqueId, event.newValue)
        .pipe(
          first()).subscribe(
            result => {
              console.log(result);
            });
    }
  }

  public refresh() {
    this.loading = true;
    this.invoices = [];
    this.getDatas();
  }

  private getDatas() {
    let getterObservable: any[] = [];
    getterObservable.push(this.getJsonObjectService.getJson("cm/invoices"));
    getterObservable.push(this.getJsonObjectService.getJson("support/companies/my"));

    forkJoin(getterObservable).subscribe(
      (getterObservableResult: any) => {
        this.initialData(getterObservableResult[0], getterObservableResult[1]);
      }
    );
  }

  private initialData(invoices: any[], societyList: any[]) {
    if (Array.isArray(invoices)) {
      invoices.forEach(invoice => {
        if (societyList.find((society: any) => society.companyUniqueId == invoice.companyUniqueId) != null)
          invoice.subscriberName = societyList.find((society: any) => society.companyUniqueId == invoice.companyUniqueId).companyName;
        if (invoice?.documentFileSize > 0) {
          invoice.download = environment.url + "cm/invoices/" + invoice.invoiceUniqueId + "/document?access_token=" + this.deviceService.decryptDataLocalStorage('userSession').currentUser;
        }
        invoice["id"] = invoice.invoiceUniqueId;
        this.invoices.push(invoice);
      })
    }
    this.loading = false;
  }
}
